export default defineNuxtPlugin(() => {
  const { $bus } = useNuxtApp()
  const router = useRouter()
  const route = useRoute()

  $bus.on('auth:unauthorized', () => {
    router.push({ name: 'admin-auth-login', query: { redirect: route.fullPath } })
  })
})
